<div class="container-inner">
  <h2 class="text-center mt-3 title-light">
    <span class="lighter">Please select an area...</span>
  </h2>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="card mt-3 bg-dark relative">
        <div class="card-body">
          <h3>
            <a [routerLink]="['/programme', 'progress']" class="stretched-link">
              <span class="icon-wrap float-end text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
            <span class="icon-wrap me-1"
              ><fa-icon [icon]="['fas', 'chart-line-up']"></fa-icon
            ></span>
            Overall Progress
          </h3>
          <div *ngIf="daysToSurgery && daysToSurgery > 0">
            <div class="d-flex align-items-center">
              <div>
                <span class="icon-wrap me-1"
                  ><fa-icon [icon]="['fal', 'hourglass-start']"></fa-icon
                ></span>
              </div>
              <div style="flex-grow: 1" class="relative">
                <span
                  style="left: {{ sugeryDateProgress }}%"
                  class="icon-wrap bg-primary text-dark d-flex justify-content-center align-items-center rounded-circle progress-tracker-icon"
                  ><fa-icon [icon]="['fas', 'user']"></fa-icon
                ></span>
                <div class="progress" style="height: 6px; width: 100%">
                  <div
                    class="progress-bar bg-primary"
                    role="progressbar"
                    style="width: {{ sugeryDateProgress }}%"
                    [attr.aria-valuenow]="sugeryDateProgress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              <div>
                <span class="icon-wrap me-1"
                  ><fa-icon [icon]="['far', 'flag-checkered']"></fa-icon
                ></span>
              </div>
            </div>
            <div class="card-text" *ngIf="userData && userData.surgery_date">
              Surgery Date:
              {{ userData.surgery_date | customDate : "ddd Do MMM" }}
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-3 bg-dark relative">
        <div class="card-body">
          <h3>
            <a
              [routerLink]="['/programme', 'task-list']"
              class="stretched-link"
            >
              <span class="icon-wrap float-end text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
            <span class="icon-wrap me-1"
              ><fa-icon [icon]="['fas', 'ballot-check']"></fa-icon
            ></span>
            Weekly Objectives
          </h3>
        </div>
      </div>

      <div class="card mt-3 bg-dark relative">
        <div class="card-body">
          <h3>
            <a
              [routerLink]="['/programme', 'weekly-reports']"
              class="stretched-link"
            >
              <span class="icon-wrap float-end text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
            <span class="icon-wrap me-1"
              ><fa-icon [icon]="['fas', 'file-chart-column']"></fa-icon
            ></span>
            Weekly Reports
          </h3>

          <div class="weeks-indicator mt-2 mb-2" *ngIf="currentWeekNumber">
            <div
              class="week"
              *ngFor="
                let e of [].constructor(currentWeekNumber - 1);
                let index = index
              "
            >
              <div class="day-label">W{{ index + 1 }}</div>
              <div class="day-status-lg day-status-circle">
                <div class="day-status-title">
                  <span
                    class="icon-wrap"
                   
                  >
                    <fa-icon [icon]="['fas', 'check']" *ngIf="reportsRead.indexOf(index + 1) !== -1"></fa-icon>
                    <span  *ngIf="reportsRead.indexOf(index + 1) == -1">&nbsp;</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <button
            *ngIf="currentWeekNumber"
            class="btn btn-primary btn-sm"
            (click)="onShowReport(+currentWeekNumber - 1)"
          >
            Latest Report
            <span class="icon-wrap"
              ><fa-icon [icon]="['fas', 'circle-chevron-right']"></fa-icon
            ></span>
          </button>
        </div>
      </div>

      <div class="card mt-3 bg-dark relative">
        <div class="card-body">
          <h3>
            <a
              [routerLink]="['/programme', 'achievements']"
              class="stretched-link"
            >
              <span class="icon-wrap float-end text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
            <span class="icon-wrap me-1"
              ><fa-icon [icon]="['fas', 'medal']"></fa-icon
            ></span>
            Achievements
          </h3>
          <div class="card-text">
            <div><strong>Milestones:</strong> {{countAchievements('badge-total')}} badges earned</div>
            <div><strong>Streaks:</strong> {{countAchievements('week-streak')}}  badges earned</div>
          </div>
        </div>
      </div>

      <div class="card mt-3 bg-dark relative">
        <div class="card-body">
          <h3>
            <a [routerLink]="['/programme', 'about']" class="stretched-link">
              <span class="icon-wrap float-end text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
            <span class="icon-wrap me-1">
              <img
                src="/assets/img/device-prepwell.svg"
                alt="The Prepwell logo"
            /></span>
            About the Programme
          </h3>
          <div class="card-text">
            Includes the programme introduction and Live Well pages.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
